<script setup lang="ts">
import { cn } from "@voltalis/frontend-utils";
import { computed } from "vue";

import { getStringAcronym } from "@/utils/string-utils";
import { ISystemColor, stringToSystemColour } from "@/utils/style-utils";

import Skeleton from "primevue/skeleton";

interface IProps {
  name?: string;
}

const props = defineProps<IProps>();

const colorBadge = computed<ISystemColor>(() => {
  return stringToSystemColour(props.name ?? "");
});
</script>

<template>
  <Skeleton
    v-if="!props.name"
    shape="circle"
    size="3rem"
  />
  <i
    v-else
    :class="
      cn('rounded-full w-12 h-12 flex justify-center items-center not-italic uppercase font-semibold shrink-0', [
        colorBadge.backgroundColor,
        colorBadge.textColor,
      ])
    "
  >
    {{ getStringAcronym(props.name) }}
  </i>
</template>
